exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".course-info[data-v-64db21e6]{padding-bottom:16px}.hd[data-v-64db21e6]{font-size:18px;line-height:24px}.hd span[data-v-64db21e6]{color:#999}.tool-btn[data-v-64db21e6]{margin-top:16px}.tool-btn a[data-v-64db21e6]{font-size:12px;color:#999}.tool-btn a[data-v-64db21e6]:hover{color:#0095ff}", ""]);

// exports
